import {
  Component, NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';
import { ThemeService } from '../../../services/theme.service';

@Component({
    selector: 'theme-switcher',
    template: `
    <dx-button
      class="theme-button"
      stylingMode="text"
      [icon]="themeService.currentThemeId && themeService.currentThemeId.includes('dark') ? 'sun' : 'moon'"
      (onClick)="onButtonClick()"
    ></dx-button>
`,
    styleUrls: [],
    standalone: false
})
export class ThemeSwitcherComponent {
  constructor(public themeService: ThemeService) {}

  onButtonClick () {
    this.themeService.switchTheme();
  }
}

@NgModule({
  imports: [CommonModule, DxButtonModule],
  declarations: [ThemeSwitcherComponent],
  exports: [ThemeSwitcherComponent],
})
export class ThemeSwitcherModule { }